module.exports = __webpack_public_path__ + "img/addcart.ff730f99.svg";